import { Area, AreaChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis, Legend } from "recharts";

const fmt = (d) => {
  const [, m, day] = d.split("-");
  return `${day}/${m}`;
};

export const ClicksChart = ({ data = [], title = "Klik affiliate harian", testId = "clicks-chart" }) => (
  <div className="rounded-2xl border border-slate-200 bg-white p-5 sm:p-6 fade-up" data-testid={testId}>
    <div className="flex items-baseline justify-between mb-4">
      <h3 className="font-bold text-slate-900">{title}</h3>
      <span className="text-xs text-slate-500">14 hari terakhir</span>
    </div>
    <div className="h-64">
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={data} margin={{ left: -20, right: 8, top: 4 }}>
          <defs>
            <linearGradient id="gShopee" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#EE4D2D" stopOpacity={0.25} />
              <stop offset="100%" stopColor="#EE4D2D" stopOpacity={0} />
            </linearGradient>
            <linearGradient id="gTiktok" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#0F172A" stopOpacity={0.2} />
              <stop offset="100%" stopColor="#0F172A" stopOpacity={0} />
            </linearGradient>
          </defs>
          <CartesianGrid stroke="#F1F5F9" vertical={false} />
          <XAxis dataKey="date" tickFormatter={fmt} tick={{ fontSize: 11, fill: "#64748B" }} axisLine={false} tickLine={false} />
          <YAxis allowDecimals={false} tick={{ fontSize: 11, fill: "#64748B" }} axisLine={false} tickLine={false} />
          <Tooltip labelFormatter={fmt} contentStyle={{ borderRadius: 12, border: "1px solid #E2E8F0", fontSize: 12 }} />
          <Legend iconType="circle" wrapperStyle={{ fontSize: 12 }} />
          <Area type="monotone" dataKey="shopee" name="Shopee" stroke="#EE4D2D" strokeWidth={2} fill="url(#gShopee)" />
          <Area type="monotone" dataKey="tiktok" name="TikTok" stroke="#0F172A" strokeWidth={2} fill="url(#gTiktok)" />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  </div>
);
